"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

require("react-datepicker/dist/react-datepicker.css");

var _ai = require("react-icons/ai");

var _io = require("react-icons/io5");

var _constants = require("./constants");

var _excluded = ["error", "errorMessage", "width", "height"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.sec-mgr-date-picker-wrapper-label {\n  color: #da1e28;\n  width: 100%; }\n\n.sec-mgr-date-picker-wrapper {\n  display: flex;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  margin-top: 0.5rem;\n  border-radius: 0.23438rem;\n  align-items: center;\n  font-size: 1.0625rem;\n  border: 0.0625rem solid #a8a8a8;\n  justify-content: space-between;\n  box-sizing: border-box; }\n\n.sec-mgr-date-picker-wrapper.sec-mgr-date-picker-wrapper-error {\n  border: none;\n  border: 0.0625rem solid #da1e28; }\n\n.sec-mgr-date-picker-wrapper .react-datepicker-wrapper {\n  width: 100%; }\n\n.sec-mgr-date-picker-wrapper input {\n  border: none;\n  width: 100%; }\n\n.sec-mgr-date-picker-wrapper svg {\n  cursor: pointer;\n  z-index: 0; }\n\n.sec-mgr-date-picker-wrapper input:focus {\n  outline: none; }\n";
  var fileName = "compone_datePickerWrapper";
  var element = document.querySelector("style[data-sass-component='compone_datePickerWrapper']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var DatePickerWrapper = function DatePickerWrapper(_ref) {
  var _wrapperClasses;

  var error = _ref.error,
      errorMessage = _ref.errorMessage,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, _excluded);

  var calender = (0, _react.useRef)(null);
  var wrapperClasses = (_wrapperClasses = {}, _defineProperty(_wrapperClasses, _constants.classes.dateWrapper, true), _defineProperty(_wrapperClasses, _constants.classes.error, Boolean(error)), _wrapperClasses);

  var handleIconClick = function handleIconClick() {
    if (calender.current) {
      calender.current.setOpen(true);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(wrapperClasses),
    style: {
      width: width,
      height: height
    }
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({}, rest, {
    ref: calender
  })), rest.showTimeSelectOnly ? /*#__PURE__*/_react.default.createElement(_io.IoChevronDown, {
    onClick: handleIconClick
  }) : /*#__PURE__*/_react.default.createElement(_ai.AiOutlineCalendar, null)), error && errorMessage && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.errorLabel
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "helper1"
  }, " ", errorMessage, " ")));
};

DatePickerWrapper.propTypes = {
  error: _propTypes.default.bool,
  errorMessage: _propTypes.default.string,
  style: _propTypes.default.any,
  width: _propTypes.default.string,
  height: _propTypes.default.string
};
var _default = DatePickerWrapper;
exports.default = _default;